import { useEffect, useState } from "react";
import Files from "../API/Files";
import useWorkspaces from "./useWorkspaces";

const useWorkspaceLogo = ({ isInWorkspace }) => {
  const { getActiveWorkspace } = useWorkspaces();
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!isInWorkspace) {
        setLogo(null);
        return;
      }
      const workspace = getActiveWorkspace();
      if (!workspace?.id || !workspace?.logo) {
        setLogo(null);
        return;
      }
      try {
        const result = await Files.downloadUrlGeneration({
          filename: `imported-image/${workspace.id}/${workspace.logo}`,
          context: "pdf",
          workspaceid: workspace.id,
        });
        const url = result?.data?.url || result?.url;
        if (!url) {
          setLogo(null);
          return;
        }
        const probe = new Image();
        probe.onload = () => {
          if (cancelled) return;
          setLogo({
            url,
            isWide: probe.naturalWidth > probe.naturalHeight * 1.5,
          });
        };
        probe.onerror = () => {
          if (cancelled) return;
          setLogo(null);
        };
        probe.src = url;
      } catch (error) {
        setLogo(null);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [isInWorkspace, getActiveWorkspace()?.id, getActiveWorkspace()?.logo]);

  return logo;
};

export default useWorkspaceLogo;
